import React, { useState } from 'react';
import styled from 'styled-components';
import { FaEye as FaEyeRaw, FaEyeSlash as FaEyeSlashRaw } from 'react-icons/fa';

const FaEye: any = FaEyeRaw;
const FaEyeSlash: any = FaEyeSlashRaw;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const StyledInput = styled.input<{ $variant?: 'default' | 'light' }>`
  width: 100%;
  padding: 0.6rem 2.5rem 0.6rem 0.75rem;
  border-radius: 10px;
  border: 1px solid var(--outline);
  background: ${({ $variant }) => ($variant === 'light' ? 'rgb(255, 255, 255)' : 'var(--surface)')};
  color: ${({ $variant }) => ($variant === 'light' ? 'rgb(0, 0, 0)' : 'var(--onSurface)')};
  box-sizing: border-box;

  &::placeholder {
    color: var(--onSurfaceVariant);
  }
`;

const ToggleButton = styled.button`
  position: absolute;
  right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border: none;
  background: transparent;
  color: var(--onSurfaceVariant);
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    color: var(--onSurface);
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
`;

type PasswordInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  variant?: 'default' | 'light';
};

const PasswordInput: React.FC<PasswordInputProps> = ({
  variant = 'default',
  id,
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <Wrapper>
      <StyledInput
        {...props}
        id={id}
        $variant={variant}
        type={visible ? 'text' : 'password'}
      />
      <ToggleButton
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        aria-controls={id}
      >
        {visible ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
      </ToggleButton>
    </Wrapper>
  );
};

export default PasswordInput;
